import { render, staticRenderFns } from "./FloatingBugReport.vue?vue&type=template&id=4e1930da&scoped=true"
import script from "./FloatingBugReport.vue?vue&type=script&lang=js"
export * from "./FloatingBugReport.vue?vue&type=script&lang=js"
import style0 from "./FloatingBugReport.vue?vue&type=style&index=0&id=4e1930da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1930da",
  null
  
)

export default component.exports